import React from 'react';
import { CollectionFilterProps } from '../../../models/CollectionFilter';
import useCollectionFilterSWR from '../../../hooks/collection/useCollectionFilterSWR';
import { CollectionFilterItem } from './CollectionFilterItem';
import { Spinner } from '../../shared/Spinner';

export const CollectionFilterItemsWrapper: React.FC<CollectionFilterProps> = (
    props
) => {
    const { handleFilter, collectionId, priceRange, preSetItems, search } =
        props;

    const { filterItems, isLoading } = useCollectionFilterSWR({
        collectionIds: collectionId ? [collectionId] : [],
        priceRange: {
            min: priceRange[0],
            max: priceRange[1],
        },
        tags: [...preSetItems],
        search: search,
    });

    return (
        <div>
            {!isLoading && filterItems && (
                <div>
                    {filterItems.map((elem, index) => (
                        <CollectionFilterItem
                            item={elem}
                            handleFilter={handleFilter}
                            key={index}
                            preSetItems={preSetItems}
                        />
                    ))}
                </div>
            )}
            {isLoading && <Spinner />}
        </div>
    );
};
